import { Component, Input, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router, NavigationEnd } from '@angular/router';
import { BehaviorSubject, Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { Constant } from 'src/app/constant/constant';
import { GoogleCalendarServiceAccountService } from 'src/app/services/google-calendar-service-account.service';
import { ListColumn } from 'src/app/shared/list/list-column.model';
import { getPageSize } from 'src/app/shared/utils/calsoft-validators';
import { DatePipe, Location } from '@angular/common';
import { AddMeetingComponent } from '../add-meeting/add-meeting.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'calsoft-leadsmeeting',
  templateUrl: './leadsmeeting.component.html',
  styleUrls: ['./leadsmeeting.component.scss']
})
export class LeadsmeetingComponent implements OnInit, OnDestroy {

  url = '';
  sanitizedUrl = '';


  @Input() type: any =1;
  @Input() leadId: any =0;
  @Input() meetingType:any = 1;
  dialerShow: boolean;
  redirected: boolean;
  textAccount: string;

  constructor(
    private googleCalendarServiceAccountService: GoogleCalendarServiceAccountService,
    private router: Router,
    private location: Location,
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
  ) {
    this.url = this.router.url || '';
    this.sanitizedUrl = this.sanitizeUrl(this.url);
    this.router.events.pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy)).subscribe(() => {
      this.url = this.router.url || '';
      this.sanitizedUrl = this.sanitizeUrl(this.url);
    });

      this.url = this.router.url || '';
          this.router.events
            .pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy))
            .subscribe(() => { this.url = this.router.url || ''; });
  }


  @Input() columns: ListColumn[] = []

  filterSelectObj = [];
  public page: any = Constant.PAGE;
  public size: any = Constant.SIZE;


  ngOnInit(): void {

    this.columns = [

      { name: 'Summary', property: 'summary', visible: true, isModelProperty: true },
      { name: 'Description', property: 'description', visible: true, isModelProperty: false },
      { name: 'Scheduled Date', property: 'startDateTime', visible: true, isModelProperty: false },
      { name: 'Link', property: 'meetLink', visible: true, isModelProperty: false },
      { name: 'Meeting Start Time', property: 'startTime', visible: true, isModelProperty: false },
      { name: 'Meeting End Time', property: 'endTime', visible: true, isModelProperty: false },
      { name: 'Status', property: 'status', visible: true, isModelProperty: true },      
      { name: 'Created Date', property: 'createdDate', visible: true, isModelProperty: false },
      { name: 'Error', property: 'error', visible: true, isModelProperty: false },
      //  { name: 'Updated Date', property: 'updatedDate', visible: false, isModelProperty: false },
      // { name: 'Created By', property: 'createdBy', visible: true, isModelProperty: true },
      { name: 'Action', property: 'actions', visible: true, disabled: true },
    ] as ListColumn[];


    this.filterSelectObj = [
      {
        name: 'Summary',
        property: 'summary',
        type: 'text',
        position: 'firstValue',
        options: []
      },
            {
        name: 'Created Date',
        property: 'startDateTime',
        type: 'date',
        position: 'secondValue',
        options: []
      },
      {
        name: 'Created Date',
        property: 'createdDate',
        type: 'date',
        position: 'secondValue',
        options: []
      },
      {
        name: 'Updated Date',
        property: 'updatedDate',
        type: 'date',
        position: 'thirdValue',
        options: []
      },
      // {
      //   name: 'Link',
      //   property: 'meetLink',
      //   type: 'text',
      //   position: 'fourthValue',
      //   options: []
      // },

      //   {
      //   name: 'Meeting Start Date',
      //   property: 'startDateTime',
      //   type: 'date',
      //   position: 'fourthValue',
      //   options: []
      // },
      // {
      //   name: 'Meeting End Date',
      //   property: 'endDateTime',
      //   type: 'date',
      //   position: 'fifthValue',
      //   options: []
      // },
      {
        name: 'Status',
        property: 'status',
        type: 'select',
        position: 'sixthValue',
        options: [
          { "viewValue": "Pending", "value": "Pending" },
          { "viewValue": "Cancel", "value": "Cancel" },
          { "viewValue": "Completed", "value": "Completed" },
          { "viewValue": "Reschedule", "value": "Reschedule" }
        ]
      },
      {
        name: 'Created By',
        property: 'createdBy',
        type: 'text',
        position: 'seventhValue',
        options: []
      },

    ]



    if (this.leadId > 0) {
      this.getAllGoogleCalendar();
    } else {

      this.googleCalendarList = [];
    }


  }

  toggleSummary(row: any) {
    row.showFullSummary = !row.showFullSummary;
  }

  toggleDescription(row: any) {
    row.showFullDescription = !row.showFullDescription;
  }

  toggleError(row: any) {
    row.showFullError = !row.showFullError;
  }


  isPopupOpenTwo = false;
  BusinessList: any = [];
  BusinessTypeList: any = [];
  filteredBusinessTypeList: any = [];

  totalElements: number = 0;
  sortParam: any = 'updatedDate' + "," + Constant.Dsc;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @Input() googleCalendarList: any = [];
  private dateFormat = Constant.dateFormat;
  paginationDetail = new BehaviorSubject(
    {
      length: 10,
      pageIndex: 0,
      pageSize: 10
    });
  spinner: boolean;
  totalLeadCount: any;
  elements: any
  pageList: any;

  pageSizeValue: any;
  sortParamInit: any = 'updatedDate' + "," + Constant.Dsc;

  getAllGoogleCalendar() {
    this.spinner = true;

    this.googleCalendarServiceAccountService.getAllGoogleCalendarNew(this.page, this.size, this.sortParam, 1, this.type, this.leadId , this.meetingType).subscribe(
      res => {
        this.spinner = false;
        this.googleCalendarList = new MatTableDataSource();
        this.googleCalendarList = res['content'];
        this.elements = res['numberOfElements'];
        this.googleCalendarList.sort = this.sort;
        this.googleCalendarList.paginator = this.paginator;
        this.pageList = res['totalElements'];
        this.pageSizeValue = getPageSize(this.pageList);
      },
      error => {
      }
    )
  }

  getUpdate(event) {

    this.paginationDetail.next(event);
    this.page = event.pageIndex;
    this.size = event.pageSize;


    let localtion = this.router.url;
    const questionMarkIndex = localtion.indexOf('?');



    if (questionMarkIndex !== -1) {
      // Extract the substring before the ?
      const beforeQuestionMark = localtion.substring(0, questionMarkIndex);

      // Replace the original string with the substring before the ?
      localtion = beforeQuestionMark;
    }

    let url = this.router.url;
    let cleanUrl = url.split('?')[0];

    localtion = localtion.split('&page')[0]


    if (this.sortParam == undefined) {

      this.sortParam = 'updatedDate' + "," + Constant.Dsc;

    }

    this.location.go(`${localtion}?page=${this.page}&size=${this.size}&sort=${this.sortParam}`)

    this.redirected = false;

    this.getAllGoogleCalendar();
  }

  get visibleColumns() {
    return this.columns.filter(column => column.visible).map(column => column.property);
  }


  sortData(event) {
     if (event.active != 'categoryNames' && event.active != 'icons' && event.active != 'select' && event.active != 'actions') {
    this.page = Constant.PAGE;
    this.size = Constant.SIZE;
    this.sortParam = event.active;
    if (event.direction == 'asc') {
      this.sortParam = this.sortParam + "," + Constant.Asc;
    } else if (event.direction == 'desc') {
      this.sortParam = this.sortParam + "," + Constant.Dsc;
    }
    this.getAllGoogleCalendar();
  }
  }


    addGoogleCalendar() {
    let id = 0;
    if(this.type==1){
      this.router.navigate([`/googleCalender/add-edit-google-calender/${id}`])
    }else{
      this.router.navigate([`/googleCalender/add-edit-google-calender/${id}/${this.leadId}`])
    }
    
  }

  //   editGoogleCalendar(id) {
  //   if(this.type==1){
  //     this.router.navigate([`/googleCalender/add-edit-google-calender/${id}`])
  //   }else{
  //     this.router.navigate([`/googleCalender/add-edit-google-calender/${id}/${this.leadId}`])
  //   }
  // }

    editGoogleCalendar(id , type) {
      const dialogRef = this.dialog.open(AddMeetingComponent, {
        width: '80%',
        maxWidth: '1200px',
        height: '100%',
        data: {
          "id": id,
          "type": type,
        },
        position: { right: '0' },
        panelClass: 'slide-dialog-panel',
        hasBackdrop: true,
        disableClose: true
      });
  
      dialogRef.afterClosed().subscribe((result) => {
      if (result && result['event'] === 'add') {
        this.getAllGoogleCalendar();
      }
    });
    }

  getRelativeTime(dateString: string): string {
    const activityDate = new Date(dateString);
    const now = new Date(); // Using component initialization time for consistency
    const diffInSeconds = Math.floor((now.getTime() - activityDate.getTime()) / 1000);

    const intervals: { [key: string]: number } = {
      'year': 31536000,
      'month': 2592000,
      'day': 86400,
      'hour': 3600,
      'minute': 60
    };

    for (const intervalName in intervals) {
      const interval = intervals[intervalName];
      const count = Math.floor(diffInSeconds / interval);
      if (count > 0) {
        return `${count} ${intervalName}${count > 1 ? 's' : ''} ago`;
      }
    }
    return 'Just now';
  }


  copyToClipboard(text: string): void {


    if(text==null || text==undefined || text==''){

          this.snackBar.open('Meeting link No Generated!', 'X', {
      duration: 3000,
      verticalPosition: 'bottom',
      panelClass: ['error'],
    });

    }else{

        const tempTextArea = document.createElement('textarea');
    tempTextArea.value = text;
    document.body.appendChild(tempTextArea);
    tempTextArea.select();
    document.execCommand('copy');
    document.body.removeChild(tempTextArea);
    this.snackBar.open('Copied to clipboard!', 'X', {
      duration: 3000,
      verticalPosition: 'bottom',
      panelClass: ['success'],
    });
    }

  
  }

    formatTime12(time: string): string {
  if (!time) return '';

  const [hours, minutes] = time.split(':').map(Number);

  const period = hours >= 12 ? 'PM' : 'AM';
  const hours12 = hours % 12 || 12;

  return `${hours12}:${minutes.toString().padStart(2, '0')} ${period}`;
}


  sanitizeUrl(u: string): string {
    return (u || '')
      .replace(/^\/+/, '')
      .replace(/[?#&=]/g, '-')
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase();
  }

    protected _onDestroy = new Subject<void>();

    ngOnDestroy() {
        this._onDestroy.next();
        this._onDestroy.complete();
    }
}





